import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi"; // Adjust path if useApi is elsewhere
import { IDaysLeftOption, IBillingCycleDaysLeftAPIRes } from "./index.type"; // Path to the types we created

const useFetchBillingCycleDaysLeft = () => {
  const [daysLeftOptions, setDaysLeftOptions] = React.useState<
    IDaysLeftOption[]
  >([]);
  const { loading, makeApiCall } = useApi({
    url: "/rtm/billing/steps",
    method: "GET",
  });

  const getBillingCycleDaysLeft = async () => {
    try {
      const { response, error } = await makeApiCall<
        undefined,
        IBillingCycleDaysLeftAPIRes
      >();

      if (error) {
        toast.error("Error fetching billing cycle days left.");
        setDaysLeftOptions([{ value: "", label: "Error loading options" }]);
        return;
      }

      if (response && response.data) {
        const transformedOptions: IDaysLeftOption[] = response.data.map(
          (item) => ({
            value: item.key,
            label: item.value,
          })
        );

        setDaysLeftOptions([
          // { value: '', label: 'Billing Cycle Days Left' },
          ...transformedOptions,
        ]);
      } else {
        setDaysLeftOptions([{ value: "", label: "No options found" }]);
      }
    } catch (e: any) {
      toast.error(
        e?.msg ||
          "Unable to load billing cycle days. Please refresh and try again."
      );
      setDaysLeftOptions([{ value: "", label: "Error loading options" }]);
      console.error(e);
    }
  };

  return {
    daysLeftOptions,
    loadingDaysLeft: loading,
    getBillingCycleDaysLeft,
  };
};

export default useFetchBillingCycleDaysLeft;
